import { Injectable } from '@angular/core';

import { PlanTier } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';
import { PricePlansQueryService } from '@tablesready/frontend-store';

@Injectable({ providedIn: 'root' })
export class PricePlansService {
  constructor(private readonly pricePlansQueryService: PricePlansQueryService) {}

  getAll(): PricePlan[] {
    return this.pricePlansQueryService.getAll();
  }

  getFree(nonUsOrCanadaUser: boolean): PricePlan {
    const plan = this.pricePlansQueryService.getFreePlan();

    return {
      ...plan,
      limit: nonUsOrCanadaUser ? Math.ceil(plan.limit * 0.1) : plan.limit,
    };
  }

  getTier(code: string): PlanTier {
    if (code.includes('reef') || code.includes('standard') || code.includes('premium')) {
      return PlanTier.premium;
    }

    const plan = this.pricePlansQueryService.getByPlanCode(code);

    return plan.tier;
  }

  getByPlanCode(code: string, nonUsOrCanadaUser: boolean): PricePlan {
    const plan = this.pricePlansQueryService.getByPlanCode(code);

    return {
      ...plan,
      limit: nonUsOrCanadaUser ? Math.ceil(plan.limit * 0.1) : plan.limit,
    };
  }

  getByTier(tier: PlanTier, nonUsOrCanadaUser: boolean): PricePlan[] {
    return this.pricePlansQueryService.getByTier(tier)
      .map(plan => ({
        ...plan,
        limit: nonUsOrCanadaUser ? Math.ceil(plan.limit * 0.1) : plan.limit,
      }));
  }
}
